import { Injectable, isDevMode } from '@angular/core';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

@Injectable()
export class GlobalErrorHandler extends ApplicationinsightsAngularpluginErrorService {
  handleError(error: any): void {
    if (isDevMode()) {
      console.error(error);
    }
    super.handleError(error);
  }
}